<template>
  <div
    class="card"
    :class="{
      'card--shadow': shadow,
      'card--white': color === 'white',
      'card--blue': color === 'blue',
      'card--green': color === 'green',
      'card--yellow': color === 'yellow',
      'card--center': center,
      'card--cursor': onClick,
    }"
    @click="onClick"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    shadow?: boolean
    color?: 'white' | 'blue' | 'green' | 'yellow'
    center?: boolean
    onClick?: () => void
  }>(),
  { shadow: true, color: 'white' },
)
</script>

<style lang="scss" scoped>
.card {
  @include flex-column;

  border: 1px solid $grey-25;
  border-radius: 15px;
  padding: 20px;
}

.card--center {
  justify-content: center;
}

.card--shadow {
  box-shadow: 0px 4px 12px 0px $grey-25;
}

.card--white {
  background-color: $white;
}

.card--blue {
  background-color: #e3f2fd;
}

.card--green {
  background-color: $green-50;
}

.card--yellow {
  background-color: $yellow-50;
}

.card--cursor {
  cursor: pointer;
}
</style>
